import $ from 'jquery';
import Swiper from 'swiper';

function entryCarousel() {
	$(document).ready(function () {
		var mySwiper = new Swiper('.js-entry-carousel', {
			speed: 400,
			spaceBetween: 35,
			slidesPerView: 5,
				breakpoints: {
				// when window width is <= 320px
				480: {
					slidesPerView: 1, spaceBetween: 10
				},
				// when window width is <= 480px
				768: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				// when window width is <= 640px
				1025: {
					slidesPerView: 3,
					spaceBetween: 30
				}
			}
		});
	});
}

export default entryCarousel;



// WEBPACK FOOTER //
// ./app/blocks/entry-carousel/entry-carousel.js